module.exports = __webpack_public_path__ + "static/img/index_bg.3f332b27.png";